import { onDomContentLoaded } from 'Functions/helpers';
import { updateLazy } from 'Functions/lazy';

import(/* webpackChunkName: "default-layout" */ "Layouts/default");
import("Common/social")

onDomContentLoaded(() => {
    updateLazy();
});